import instance from '@/api/axios'

export const adminApi = {
  async getCategories() {
    return await instance.post('/category/list', { language: 'ru' })
  },

  async createCategory(formData) {
    return await instance.post('/admin/categories', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async updateCategory(id, formData) {
    return await instance.put(`/admin/categories/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async deleteCategory(id) {
    return await instance.delete(`/admin/categories/${id}`)
  },

  async getSubcategories(categoryId) {
    return await instance.get(`/admin/subcategories/${categoryId}`)
  },

  async getChildSubcategories(parentId) {
    return await instance.get(`/admin/subcategories/${parentId}/children`)
  },

  async getElements(subcategoryId) {
    return await instance.get(`/admin/elements/${subcategoryId}`)
  },

  async checkCanAddElements(subcategoryId) {
    return await instance.get(`/admin/subcategories/${subcategoryId}/can-add-elements`)
  },

  async createSubcategory(formData) {
    return await instance.post('/admin/subcategories', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async updateSubcategory(id, formData) {
    return await instance.put(`/admin/subcategories/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async deleteSubcategory(id) {
    return await instance.delete(`/admin/subcategories/${id}`)
  },

  async createElement(formData) {
    return await instance.post('/admin/elements', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async updateElement(id, data) {
    return await instance.put(`/admin/elements/${id}`, data)
  },

  async deleteElement(id) {
    return await instance.delete(`/admin/elements/${id}`)
  },

  async getUsers() {
    return await instance.get('/admin/users')
  },

  async updateUser(id, data) {
    return await instance.put(`/admin/users/${id}`, data)
  },

  async deleteUser(id) {
    return await instance.delete(`/admin/users/${id}`)
  },

  async getBackgrounds() {
    return await instance.get('/admin/backgrounds')
  },

  async createBackground(formData) {
    return await instance.post('/admin/backgrounds', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async deleteBackground(id) {
    return await instance.delete(`/admin/backgrounds/${id}`)
  },

  async getPayments(params = {}) {
    return await instance.get('/admin/payments', { params })
  },

  async chargeRenewal(userId) {
    return await instance.post(`/admin/users/${userId}/charge-renewal`)
  },

  async impersonate(userId) {
    return await instance.post(`/admin/users/${userId}/impersonate`)
  }
}
